module.exports = __webpack_public_path__ + "images/category_lp/farm_machine/assessment_achievements/1_0369b95f74af29081b70e034d43796d4.png";